<template>
  <full-container v-loading="loading" :element-loading-text="loadingText" :padding="0">
    <div slot="header" class="toolbar">
      <el-upload :before-upload="handleUpload" action="default" :disabled="loading">
        <el-button type="primary" size="small" icon="el-icon-upload"> 选择要导入的 .xlsx 表格 </el-button>
      </el-upload>
    </div>
    <el-table :data="datalist[pape]" stripe size="small" height="100%">
      <el-table-column type="expand" :border="false">
        <el-descriptions slot-scope="{ row }" :column="5">
          <el-descriptions-item label="结存数量">{{ row.Quantity1 }}</el-descriptions-item>
          <el-descriptions-item label="结存件数">{{ row.Quantity2 }}</el-descriptions-item>
          <el-descriptions-item label="可用数量">{{ row.Quantity3 }}</el-descriptions-item>
          <el-descriptions-item label="可用件数">{{ row.Quantity4 }}</el-descriptions-item>
          <el-descriptions-item label="待发货">{{ row.Quantity5 }}</el-descriptions-item>
        </el-descriptions>
      </el-table-column>
      <el-table-column prop="Warehouse" label="货仓" min-width="60" />
      <el-table-column prop="Code" label="编码" min-width="100" />
      <el-table-column prop="Name" label="品名" min-width="150" show-overflow-tooltip />
      <el-table-column prop="Spec" label="规格" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Unit" label="主计量" min-width="60" />
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination :page-size="size" :total="total" @current-change="onPager" />
      <el-button type="primary" size="small" icon="el-icon-caret-right" :disabled="loading" @click="onSubmit(0)">开始导入</el-button>
    </div>
  </full-container>
</template>

<script>
import Vue from 'vue'
import pluginImport from '@d2-projects/vue-table-import'
Vue.use(pluginImport)
export default {
  data () {
    return {
      loading: false,
      loadingText: "",
      datalist: [],
      total: 0,
      pape: 0,
      size: 200,
    }
  },
  methods: {
    //上传文件
    handleUpload (file) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.loadingText = "正在加载文件数据..."
      this.$import
        .xlsx(file)
        .then(({ results }) => {
          this.total = results.length
          this.datalist = this.splitArr(results.map(row => {
            return {
              CompanyId: row['公司'],
              Warehouse: row['仓库名称'],
              Code: row['存货编码'],
              Name: row['存货名称'],
              Spec: row['规格型号'],
              Unit: row['主计量'],
              Quantity1: row['结存数量'],
              Quantity2: row['结存件数'],
              Quantity3: row['可用数量'],
              Quantity4: row['可用件数'],
              Quantity5: row['待发货数量'],
              ShowQuantity: row['默认展示'] == '是' ? true : false
            }
          }), this.size)
        })
        .catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          this.loading = false
        })
      return false
    },
    // 分页触发事件
    onPager (val) {
      this.pape = val - 1
    },

    //分页
    splitArr (data, senArrLen) {
      //处理成len个一组的数据
      let data_len = data.length
      let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len / senArrLen) + '') + 1
      let arrSec_len = data_len > senArrLen ? senArrLen : data_len//内层数组的长度
      let arrOuter = new Array(arrOuter_len)//最外层数组
      let arrOuter_index = 0//外层数组的子元素下标
      for (let i = 0; i < data_len; i++) {
        if (i % senArrLen === 0) {
          arrOuter_index++
          let len = arrSec_len * arrOuter_index
          //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
          arrOuter[arrOuter_index - 1] = new Array(data_len % senArrLen)
          if (arrOuter_index === arrOuter_len)//最后一组
            data_len % senArrLen === 0 ?
              len = data_len % senArrLen + senArrLen * arrOuter_index :
              len = data_len % senArrLen + senArrLen * (arrOuter_index - 1)
          let arrSec_index = 0//第二层数组的索引
          for (let k = i; k < len; k++) {//第一层数组的开始取决于第二层数组长度*当前第一层的索引
            arrOuter[arrOuter_index - 1][arrSec_index] = data[k]
            arrSec_index++
          }
        }
      }
      return arrOuter
    },
    //提交数据
    onSubmit (index) {
      if (index < 0) { index = 0 }

      if (!this.loading) {
        this.loading = true
      }
      this.loadingText = "正在上传第" + (index + 1) + "页"
      this.$apis.product.stock.import(this.datalist[index])
        .catch((res) => {
          this.$message.error(res)
        })
        .finally(() => {
          if (!this.datalist[index + 1]) {
            this.$message({ message: '数据全部已上传', type: 'success' })
            this.loading = false
          }
          else {
            this.onSubmit(index + 1)
          }
        })
    }
  }
}
</script>
